/**
 * Bitmoji
 *
 * Exposes its avatar UI assets; identifies the visitor as a Snapchat account holder.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 11.0.0.
 */
import { probeFetch, probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'bfgdeiadkckfbkeigkoncpdieiiefpig';
export const bitmoji: ExtensionDefinition = {
  id: ID,
  name: "Bitmoji",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  notes: "Exposes its avatar UI assets; identifies the visitor as a Snapchat account holder.",
  signals: [
    { id: 'war-popup-html', kind: 'web-accessible-resource',
      description: 'Fetch popup.html, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'popup.html') },
    { id: 'war-static-media-bitmoji-loader-svg', kind: 'web-accessible-resource',
      description: 'Load static/media/bitmoji-loader.svg via <img>, exposed to every origin.',
      weight: 0.5, run: () => probeImage(ID, 'static/media/bitmoji-loader.svg') },
  ],
};
